<template>
  <el-sub-menu v-if="visibleChildren.length" :index="groupIndex">
    <template #title>
      <el-icon v-if="menuIcon"><component :is="menuIcon" /></el-icon>
      <span>{{ label }}</span>
    </template>
    <AdminSidebarMenuItem
      v-for="child in visibleChildren"
      :key="child.id"
      :item="child"
      @navigate="emit('navigate')"
    />
  </el-sub-menu>
  <el-menu-item v-else-if="menuTarget.kind === 'route'" :index="menuTarget.routePath">
    <el-icon v-if="menuIcon"><component :is="menuIcon" /></el-icon>
    <span>{{ label }}</span>
  </el-menu-item>
  <el-menu-item v-else-if="menuTarget.kind === 'new-page'" :index="menuTarget.index" class="admin-sidebar-menu-item--link">
    <a
      :href="menuTarget.href"
      target="_blank"
      rel="noopener noreferrer"
      class="admin-sidebar-menu-item__link"
      @click.stop="emit('navigate')"
    >
      <el-icon v-if="menuIcon"><component :is="menuIcon" /></el-icon>
      <span>{{ label }}</span>
    </a>
  </el-menu-item>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { resolveAdminMenuTarget } from '@/router/admin-menu-url'
import {
  getVisibleAdminMenus,
  resolveAdminMenuLabel
} from '@/apps/admin/utils/menu-presentation'
import { resolveAdminMenuIcon } from '@/apps/admin/utils/menu-icon'
import type { AdminMenuRouteSource } from '@/shared/types/admin'

defineOptions({ name: 'AdminSidebarMenuItem' })

const props = defineProps<{ item: AdminMenuRouteSource }>()
const emit = defineEmits<{ navigate: [] }>()
const { t } = useI18n()

const visibleChildren = computed(() => {
  return getVisibleAdminMenus(props.item.children || [])
})
const menuTarget = computed(() => resolveAdminMenuTarget(props.item))
const label = computed(() => resolveAdminMenuLabel(props.item, t))
const groupIndex = computed(() => menuTarget.value.kind === 'route'
  ? menuTarget.value.routePath
  : `admin-menu-group-${props.item.id}`)
const menuIcon = computed(() => resolveAdminMenuIcon(
  props.item.icon,
  visibleChildren.value.length > 0
))
</script>

<style scoped>
.admin-sidebar-menu-item__link {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  color: inherit;
  text-decoration: none;
}

.admin-sidebar-menu-item__link .el-icon {
  flex: 0 0 auto;
}
</style>
